var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPopup
    ? _c(
        "div",
        {
          staticClass: "Module_popup fc",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onClone1($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "content_box",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSmallDivClick($event)
                },
              },
            },
            [
              _c("div", { staticClass: "content_header frb" }, [
                _c("div", [_vm._v(_vm._s(_vm.titleName))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fc pointer",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onClone($event)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "20px", height: "20px" },
                      attrs: {
                        src: require("@/assets/homeDecoration/Cross.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content_body" }, [
                _vm.isSubmoduleNot
                  ? _c(
                      "div",
                      [
                        _vm.platformCodeData
                          ? _c(
                              "el-tabs",
                              {
                                attrs: { value: _vm.queryData.locationCode },
                                on: { "tab-click": _vm.handleClick },
                              },
                              _vm._l(_vm.platformCodeData, function (item) {
                                return _c("el-tab-pane", {
                                  key: item.id,
                                  attrs: {
                                    label: item.locationName,
                                    name: item.locationCode,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "search_criteria" }, [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入活动名称", clearable: "" },
                        model: {
                          value: _vm.queryData.activityName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryData, "activityName", $$v)
                          },
                          expression: "queryData.activityName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "状态", clearable: "" },
                          model: {
                            value: _vm.queryData.bannerEnable,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryData, "bannerEnable", $$v)
                            },
                            expression: "queryData.bannerEnable",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 1, label: "上线" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 0, label: "下线" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      staticStyle: { width: "fit-content" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onInquire },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "ml10",
                          attrs: { type: "info", plain: "" },
                          on: { click: _vm.onInitialize },
                        },
                        [_vm._v("重置")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "ml10",
                          attrs: { type: "info", plain: "" },
                          on: { click: _vm.onAdd },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "search_content_box" }, [
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "550",
                            data: _vm.tableData,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "icon",
                              label: "图片",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px",
                                          "border-radius": "8px",
                                        },
                                        attrs: {
                                          src: scope.row.pic,
                                          "preview-src-list": [scope.row.pic],
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1752531655
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "icon",
                              label: "标签",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return scope.row.tag
                                      ? [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              "border-radius": "8px",
                                            },
                                            attrs: {
                                              src: scope.row.tag,
                                              "preview-src-list": [
                                                scope.row.tag,
                                              ],
                                            },
                                          }),
                                        ]
                                      : undefined
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sort",
                              label: "排序",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "名称",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "effective",
                              label: "活动类型",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.jumpType === 3
                                        ? _c("div", [
                                            Number(scope.row.activityType) === 1
                                              ? _c("div", [
                                                  _vm._v("自定义活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 2
                                              ? _c("div", [_vm._v("官方活动")])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 3
                                              ? _c("div", [
                                                  _vm._v("聚合页活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 4
                                              ? _c("div", [
                                                  _vm._v("通用H5活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 5
                                              ? _c("div", [
                                                  _vm._v("自定义页面（旧版）"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 6
                                              ? _c("div", [
                                                  _vm._v("商品列表活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 7
                                              ? _c("div", [
                                                  _vm._v("第三方代下单"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 8
                                              ? _c("div", [
                                                  _vm._v("礼金补贴活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 9
                                              ? _c("div", [
                                                  _vm._v("超级补贴活动"),
                                                ])
                                              : Number(
                                                  scope.row.activityType
                                                ) === 10
                                              ? _c("div", [
                                                  _vm._v("自定义页面"),
                                                ])
                                              : _c("div", [_vm._v("-")]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.jumpType === 2
                                        ? _c("div", [
                                            scope.row.openUrl
                                              ? _c("span", [_vm._v("url跳转")])
                                              : _c("span", [_vm._v("-")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2462116977
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "activityName",
                              label: "活动名称",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            scope.row.activityName || "-"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3424280346
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "enable",
                              label: "状态",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            scope.row.enable ? "上线" : "下线"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              510390360
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "startTime",
                              label: "开始时间",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "endTime",
                              label: "结束时间",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              width: "150",
                              label: "操作",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "fc" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "Operation_button fc",
                                            staticStyle: { color: "#83C1FF" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEditor(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "14px",
                                                height: "14px",
                                              },
                                              attrs: {
                                                src: require("@/assets/LittleActivityCreation/editor.png"),
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("编辑")]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Operation_button ml10 fc",
                                            staticStyle: {
                                              border: "1px solid #E96E7E",
                                              color: "#E96E7E",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "14px",
                                                height: "14px",
                                              },
                                              attrs: {
                                                src: require("@/assets/LittleActivityCreation/delete.png"),
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("删除")]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3914452856
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt20 page_box" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.queryData.page.page,
                              "page-sizes": [10, 20, 30, 40],
                              "page-size": _vm.queryData.page.size,
                              layout: "total, prev, pager, next, sizes,jumper",
                              total: _vm.pagination.total,
                              background: "",
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("SetupModulePopup", {
            ref: "setupModulePopup",
            on: { RefreshList: _vm.onRefreshList },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }